import type { Issue } from '@/lib/intake/rules';

/** Ids for the hint and the message, which the control names as its description. */
export function describedBy(id: string, hint: string | undefined, issues: readonly Issue[]): string | undefined {
  const ids = [hint ? `${id}-hint` : null, issues.length > 0 ? `${id}-message` : null].filter(Boolean);
  return ids.length > 0 ? ids.join(' ') : undefined;
}
